module.exports = __webpack_public_path__ + "static/img/fd_hna_logo.52218b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fd_hna_logo.png
// module id = tT9L
// module chunks = 5